// extracted by mini-css-extract-plugin
module.exports = {"c9wq49b":"c9wq49b","l2ctld5":"l2ctld5"};